import { Box, Stack, Typography } from '@mui/material';

/**
 * PageHeader — standard page title band.
 *
 * @param {string}          title      — Page title
 * @param {string|ReactNode} [subtitle] — Supporting line under the title
 * @param {ReactNode}       [actions]  — Right-aligned action buttons
 * @param {ReactNode}       [children] — Optional extra content below the title row
 * @param {object}          [sx]       — Root overrides
 */
const PageHeader = ({ title, subtitle, actions, children, sx }) => (
  <Box sx={{ mb: 3, ...sx }}>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      spacing={1.5}
    >
      <Box>
        <Typography variant="h4" component="h1" sx={{ letterSpacing: '-0.02em' }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          {actions}
        </Stack>
      )}
    </Stack>
    {children}
  </Box>
);

export default PageHeader;
